import AHDate from "_shared/dates/date";
import Guid from "_shared/guids/guid";
import BookmarksResponseSchema, { BookmarksResponseJSON, BookmarksResponseParams } from "marketplace/bookmarks/_schema/bookmarks-response-schema";
import BookmarkedCompany from "marketplace/bookmarks/company-bookmarks/bookmarked-company";
import BookmarkedIndividual from "marketplace/bookmarks/individual-bookmarks/bookmarked-individual";
import BookmarkedTeam from "marketplace/bookmarks/team-bookmarks/bookmarked-team";

export interface Bookmark {
  id: Guid;
  createdDate: AHDate;
  type: BookmarkType;
}

export type AnyBookmark = BookmarkedCompany | BookmarkedIndividual | BookmarkedTeam;

export class Bookmarks {
  public static fromJSON(json: BookmarksResponseJSON): Bookmarks {
    const parsed = BookmarksResponseSchema.deserialize(json);
    return new Bookmarks(parsed);
  }

  public readonly company: BookmarkedCompany[] = [];
  public readonly individual: BookmarkedIndividual[] = [];
  public readonly team: BookmarkedTeam[] = [];

  public constructor(params: BookmarksResponseParams) {
    this.company = params.company.map((c) => BookmarkedCompany.create(c));
    this.individual = params.individual.map((i) => BookmarkedIndividual.create(i));
    this.team = params.team.map((t) => BookmarkedTeam.create(t));
  }

  public toJSON(): BookmarksResponseJSON {
    return BookmarksResponseSchema.serialize(this);
  }
}

export enum BookmarkType {
  Company = "company",
  Individual = "individual",
  Team = "team",
}
